//src/app/services/announcements.ts
import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from './index';

export type IAnnouncement = {
  id: number;
  title: string;
  description: string;
  started_at: string;
  ended_at: string;
  audience: 'clients' | 'accountants' | 'all';
};

export const PormoCodesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncements: builder.query<
      IPaginatedRepsonse<IAnnouncement>,
      IGetQueryParams<{}>
    >({
      query: (params) => `/announcements${buildQueryParams(params)}`,
    }),

    updateAnnouncement: builder.mutation<
      IAnnouncement,
      Partial<IAnnouncement> & { id: number }
    >({
      query: (announcement) => ({
        url: `/announcements/${announcement.id}`,
        method: 'PUT',
        body: { announcement },
      }),
    }),
    createAnnouncement: builder.mutation<IAnnouncement, IAnnouncement>({
      query: (announcement) => ({
        url: `/announcements`,
        method: 'POST',
        body: { announcement },
      }),
    }),
    deleteAnnouncement: builder.mutation({
      query: (id: number) => ({
        url: `/announcements/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useLazyGetAnnouncementsQuery,
  useUpdateAnnouncementMutation,
} = PormoCodesApi;
